export default "__VITE_ASSET__1b4c9bcf__"